import * as React from "react";
import { Grid, Button } from "semantic-ui-react";
import { get } from "lodash";

import { EditableField, fromPrompt, PlayerPostDialog, SharedPostFlowDefaults } from "@/components";
import * as DTO from "../../../../../../../interfaces";

import "./styles.scss";
import { PromptCard } from "@/components";
interface OwnProps {
  promptList: DTO.PlayerPrompt[];
  name: string;
  category?: DTO.Category;
  disable?: boolean;
  deliveryMode?: DTO.DeliveryMode;
}

type Props = OwnProps;

const CategorySectionFC: React.FC<Props> = ({ category, promptList, name }) => {
  const [display, setDisplay] = React.useState<boolean>(true);
  const [showPostModal, setShowPostModal] = React.useState<boolean>(false);
  const [selectedPrompt, setSelectedPrompt] = React.useState<DTO.Prompt | undefined>(undefined);

  const actionTitle = (): string => {
    if (!display) {
      return "Expand (" + promptList.length + ")";
    }
    return "Collapse (" + promptList.length + ")";
  };

  const postDefaults: SharedPostFlowDefaults | undefined = React.useMemo(() => {
    if (selectedPrompt) return fromPrompt(selectedPrompt);
    else return undefined;
  }, [selectedPrompt]);

  const categoryName = get(category, "categoryId", name);
  return (
    <Grid
      columns={3}
      data-elm-id={"library-list-element-" + categoryName}
      key={"library-list-element-" + categoryName}
      className={display ? "libraryListCategoryGrid" : "libraryListCategoryGrid collapsed"}
    >
      <Grid.Row columns={3} className={display ? "libraryListCategoryGrid" : "libraryListCategoryGrid collapsed"}>
        <EditableField
          headerType={"h2"}
          name={"playerLibraryCategoryId" + categoryName}
          currentValue={name}
          handleChangeValue={() => {}}
          disable={true}
        />

        <Grid.Column width={3} floated="right" className={"noBorder"}>
          <Button
            basic
            data-elm-id={`librarySectionDisplayBtn`}
            content={actionTitle()}
            icon={!display ? "triangle right" : "triangle down"}
            className={"noBorder floatRight"}
            labelPosition={"right"}
            onClick={() => setDisplay(!display)}
          />
        </Grid.Column>
      </Grid.Row>

      <div className={"flex gap-x-5 " + (display ? "flex-wrap" : "overflow-auto h-fit")}>
        {promptList.map((prompt, index) => {
          return (
            <PromptCard
              key={`player_library_prompt_card_${index}_${prompt.prompt.promptId}`}
              prompt={{ ...prompt.prompt, creationDate: prompt.deliveryDateTime }}
              onClick={() => {
                setShowPostModal(true);
                setSelectedPrompt(prompt.prompt);
              }}
            />
          );
        })}
      </div>
      {showPostModal && postDefaults && (
        <PlayerPostDialog
          open={showPostModal}
          handleClose={() => {
            setShowPostModal(false);
            setSelectedPrompt(undefined);
          }}
          defaults={postDefaults}
        />
      )}
    </Grid>
  );
};

export const CategorySection = CategorySectionFC;
